import { useState } from 'react';

import { Icon, Tooltip } from '~/components';

import type { TooltipSize } from '../Tooltip';

interface InfoTooltipProps {
  content: string;
  delayDuration?: number;
  sideOffset?: number;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  size?: TooltipSize;
}

export function InfoTooltip({
  content,
  delayDuration = 0,
  sideOffset = 16,
  side = 'top',
  align = 'end',
  size = 'md',
}: InfoTooltipProps) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <Tooltip
      content={
        <div className="flex flex-col gap-sm leading-5">
          <p>{content}</p>
        </div>
      }
      delayDuration={delayDuration}
      sideOffset={sideOffset}
      side={side}
      align={align}
      triggerAsChild
      size={size}
      onOpenChange={setIsTooltipOpen}
    >
      <span className="flex">
        <Icon
          className="cursor-pointer"
          type="circle-info"
          variant={isTooltipOpen ? 'solid' : 'light'}
          size="sm"
        />
      </span>
    </Tooltip>
  );
}
InfoTooltip.displayName = 'InfoTooltip';
